import {useEffect, useState} from "react";
import Form from "./components/Form";
import Notes from "./components/Notes";
import Modal from "./components/Modal";
import {db} from "./firebase";
import {ref, onValue} from "firebase/database";
import './App.css';

function App() {
  const [notes, setNotes] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [activeNote, setActiveNote] = useState('');

  const activeNoteObj = notes.filter((item => item.id === activeNote));

  function getNotes() {
    onValue(ref(db), (snapshot) => {
      setNotes([]);

      const data = snapshot.val();

      if (data !== null) {
        Object.values(data).map((todo) => {
          setNotes((oldArray) => [...oldArray, todo]);
          return null;
        });
      }
    });
  }

  useEffect(() => {
    getNotes();
  }, [])

  return (
    <div className="body-container">
      <header><h1 className="title-h1">My notes</h1></header>
      <main className="main-container">
        <section className="section-container">
          <Form notes={notes} setNotes={setNotes}/>
          <Notes 
            notesAll={notes}
            notesFiltred={notes.filter((item => item.status === "active"))} 
            setNotes={setNotes} 
            setShowModal={setShowModal} 
            setActiveNote={setActiveNote} 
            type="Active"
          />
          <Notes 
            notesAll={notes}
            notesFiltred={notes.filter((item => item.status === "archive"))} 
            setNotes={setNotes} 
            setShowModal={setShowModal} 
            setActiveNote={setActiveNote} 
            type="Archive"
          />
        </section>
      </main>
      {showModal && <Modal setShowModal={setShowModal} note={activeNoteObj[0]} notes={notes}/>}
    </div>
  );
}

export default App;
